import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { createStore } from 'vuex-extensions'

import Common from './Common'
import User from './User'
import Customer from './Customer'
import Supplier from './Supplier'
import Sale from './Sale'
import Product from './Product'
import Order from './Order'
import Loading from './Loading'
import Storage from './Storage'
import Ship from './Ship'
import NotePhrase from './NotePhrase'
import PaymentMethod from './PaymentMethod'
import Refund from './Refund'
import StockMove from './StockMove'
import Stock from './Stock'
import TransferAccount from './TransferAccount'
import CombinedBill from './CombinedBill'
import Jdproduct from './Jdproduct'
import OftenUse from './OftenUse'
import FileStore from './File'
import BalanceOfPayment from './BalanceOfPayment'
import Kpi from './Kpi'
import Nextengine from './Nextengine'
import Notice from './Notice'
import Shop from './Shop'
import Inquiry from './Inquiry'
import Platform from './Platform'
import UI from './UI'
import Auth from './Auth'

Vue.use(Vuex)

const store = {
  state: {},
  mutations: {},
  actions: {},
  modules: {
    Common,
    User,
    Customer,
    Supplier,
    Sale,
    Product,
    Order,
    Loading,
    Storage,
    Ship,
    NotePhrase,
    PaymentMethod,
    Refund,
    StockMove,
    Stock,
    TransferAccount,
    CombinedBill,
    Jdproduct,
    OftenUse,
    FileStore,
    BalanceOfPayment,
    Kpi,
    Nextengine,
    Notice,
    Shop,
    Inquiry,
    Platform,
    UI,
    Auth
  },
  plugins: [
    createPersistedState({
      key: 'spesOrder',
      paths: ['Common'],
      storage: window.localStrage
    })
  ]
}

export default createStore(Vuex.Store, store)
